/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

type Props = {
  width?: string;
  height?: string;
  cssOverride?: Interpolation;
};

const shimmer = keyframes`
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
`;

const styles = {
  container: (widthOverride?: string, heightOverride?: string) => css`
    position: relative;
    display: block;
    width: ${widthOverride || '100%'};
    height: ${heightOverride || '100%'};
    animation: ${shimmer} 2.2s infinite linear;
    background: var(--cds-color-grey-50);
    background: linear-gradient(
      to right,
      var(--cds-color-grey-25) 8%,
      var(--cds-color-grey-50) 18%,
      var(--cds-color-grey-25) 33%
    );
    background-size: 1200px 100%;
  `,
};

/**
 * Renders Loading Skeleton.
 * It was implemented before CDS version was available.
 *
 * @deprecated Use CDS `Skeleton`
 * @param Props
 * @returns React.JSX.Element
 */
const LoadingSkeleton = ({ width, height, cssOverride }: Props) => {
  return <div css={[styles.container(width, height), cssOverride]} data-testid="lazy-load" />;
};

export default LoadingSkeleton;
